import React from 'react';
import styles from './MottoComponent.module.css';
import '../styles/theme.css';

function MottoComponent() {
  return (
    <section className={styles['motto']}>
      <div className={styles['motto-inner']}>
        <div className={styles['motto-latin']}>
          <span>P<span className={styles['motto-tail']}>rimum</span> </span>
          <span className={styles['motto-block']}>
            {/* Fuzzy translucent spray-cloud surface, 50% opacity */}
            <svg
              aria-hidden="true"
              viewBox="0 0 400 100"
              preserveAspectRatio="none"
              className={styles['motto-block-bg']}
            >
              <defs>
                <filter id="motto-spray-cloud" x="-10%" y="-20%" width="120%" height="140%">
                  <feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="2" seed="3" />
                  <feDisplacementMap in="SourceGraphic" scale="16" />
                  <feGaussianBlur stdDeviation="0.5" />
                </filter>
              </defs>
              <g filter="url(#motto-spray-cloud)">
                <rect x="22" y="22" width="356" height="56" fill="#FFC700" opacity="0.5" rx="6" />
              </g>
            </svg>
            <span className={styles['motto-block-text']}>N<span className={styles['motto-tail']}>on</span>&nbsp;D<span className={styles['motto-tail']}>esipere</span></span>
          </span>
        </div>
        <p className={styles['motto-explanation']}>
          <em>“First, do not act foolishly.”</em> A commitment to wisdom and
          discernment, reflecting the pursuit of excellence and thoughtful
          consideration in all we do.
        </p>
      </div>
    </section>
  );
}

export default MottoComponent;
